import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getCollectionOffers } from '@/api/loans';
import { ICollectionOffers } from '@/redux/loans/model';
import { GET_COLLECTION_OFFERS } from '@/utils/queryKey';

export const useBestOfferCollection = (collectionSlug: string | undefined, queryProps?: Omit<UseQueryOptions<ICollectionOffers>, 'queryKey' | 'queryFn' | 'select'>) => {
  return useQuery({
    queryKey: [GET_COLLECTION_OFFERS, collectionSlug],
    queryFn: () => {
      return getCollectionOffers(collectionSlug!);
    },
    select: ({ offers }) => {
      return offers[0];
    },
    enabled: !!collectionSlug,
    ...queryProps,
  });
};
